module.exports = __webpack_public_path__ + "img/blue-plus-icon.aa5a229c.svg";